/**
 * Common utility functions
 * Provides UUID generation, JSON parsing, money formatting, market-aware URLs, and global state access
 */

import { v4 as uuidv4 } from 'uuid'
import { formatMoney as shopifyFormatMoney, withCurrencyCode } from './currency-formatter'

function generateID() {
  return uuidv4()
}

function parseJSON(input: string | object, defaultReturnType = 'object') {
  if (typeof input === 'object') return input
  if (!input) return defaultReturnType === 'object' ? {} : []
  try {
    return JSON.parse(input.replace(/(&quot;)/g, '"'))
  } catch (err) {
    console.error('Could not parse input in parseJSON.', parseJSON, err)
    return defaultReturnType === 'object' ? {} : []
  }
}

const globalState = window.globals
const formatMoney = function (cents: number | string, format = globalState.shopify.moneyFormat) {
  return shopifyFormatMoney(cents, format)
}

const formatMoneyWithCurrency = function (cents: number | string, format = globalState.shopify.moneyFormat) {
  return withCurrencyCode(shopifyFormatMoney(cents, format), globalState.shopify.currencySymbol, globalState.shopify.currency)
}

function localeUrl(path: string): string {
  const root = globalState?.routes?.root || (window as any).Shopify?.routes?.root || '/'
  return `${root.replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`
}

function localeSearchUrl(query?: string): string {
  const base = globalState?.routes?.search_url || localeUrl('search')
  return query ? `${base}?query=${encodeURIComponent(query)}` : base
}

export {
  formatMoney,
  formatMoneyWithCurrency,
  globalState,
  localeSearchUrl,
  localeUrl,
  parseJSON,
  generateID
}
